/**
 * Shared lead-submission helper (Growth Platform — Slices S3/S4).
 *
 * Wraps the existing EmailJS pipeline so lead forms (Device Health Check,
 * Business Accounts, future landing pages) don't duplicate credentials or
 * boilerplate. Payload matches the existing EmailJS template contract
 * (name, email, reply_to, device, subject, message).
 *
 * When the MERN backend lands, repoint this ONE function at /api/leads and
 * every lead form migrates at once.
 */

import emailjs from "@emailjs/browser";

const SERVICE_ID = "service_f4grfuj";
const TEMPLATE_ID = "template_bjg4ob4";
const PUBLIC_KEY = "LyFrQSP0J8xcnoKSH";

/**
 * @param {Object} fields
 * @param {string} fields.name
 * @param {string} fields.email
 * @param {string} [fields.phone]
 * @param {string} fields.subject   - lead type / summary line
 * @param {string} fields.message   - full structured details
 * @param {string} [fields.device]  - optional device/context label
 * @returns {Promise}
 */
export function submitLead({ name, email, phone, subject, message, device }) {
  const body = phone ? `${message}\n\nPhone: ${phone}` : message;
  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      name,
      email,
      reply_to: email,
      device: device || "N/A",
      subject,
      message: body,
    },
    { publicKey: PUBLIC_KEY }
  );
}
